import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Typography } from "@mui/material";

const ContactTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("accesstoken");

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://rohan-tax-services.onrender.com/api/auth/fetchreq",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              role: role,
            }),
          }
        );
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching contact data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "comapany",
      header: "Company",
    },
    {
      accessorKey: "mobile",
      header: "Mobile",
    },
    {
      accessorKey: "email",
      header: "Email",
    },
    {
      accessorKey: "subject",
      header: "Subject",
    },
    {
      accessorKey: "message",
      header: "Message",
      Cell: ({ cell }) => (
        <Typography
          variant="body2"
          sx={{
            maxHeight: 80,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {cell.getValue()}
        </Typography>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        state={{ isLoading: loading }}
      />
    </div>
  );
};

export default ContactTable;
